import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";
import * as serviceWorker from "./serviceWorker";
import { Amplify } from "aws-amplify";
import amplifyConfigure from "./amplify-configure";
import "./index.css";

const requireScrollPolyfill = async () =>
  !("scrollBehavior" in document.documentElement.style) &&
  (await import("scroll-behavior-polyfill"));

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: amplifyConfigure.COGNITO.REGION,
    userPoolId: amplifyConfigure.COGNITO.USER_POOL_ID,
    userPoolWebClientId: amplifyConfigure.COGNITO.APP_CLIENT_ID,
    authenticationFlowType:
      "USER_SRP_AUTH" | "USER_PASSWORD_AUTH" | "CUSTOM_AUTH",
    oauth: amplifyConfigure.COGNITO.oauth,
  },
});

requireScrollPolyfill().then(() =>
  ReactDOM.render(<App />, document.getElementById("root"))
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
